import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'

export default {
  name      : 'Pages',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      items: []
    }
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(item => item.group === this.$route?.meta?.group)
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
